import React from "react";
import TextInput from "./TextInput";
import FixButton from "./Button";
import AddRata from "./AddRataWidget";
import RataStatusWidgetCorso from "./RataStatusWidgetCorso";
import moment from "moment";
import Cookies from "universal-cookie";
import getPianoPagamentiCorso from "../services/getPianoPagamentiCorso";

export default class GestioneRateCorsoWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      costo: 0,
      showAddRata: false,
      custom: this.props.custom,
      piano: this.props.piano,
      isLoading: true,
    };
  }

  async reload() {
    const corsoId = this.props.corso.id;
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    this.pianoPagamentoCorso = await getPianoPagamentiCorso(
      username,
      token,
      corsoId
    );

    this.setState({ status: this.pianoPagamentoCorso, isLoading: false });
  }

  aggiungiRata() {
    this.setState({ showAddRata: true });
  }

  async componentDidMount() {
    await this.reload();
  }

  salva() {
    if (!this.state.piano || !this.state.piano.costo) {
      alert("Errore nel campo COSTO");
      return;
    }

    const costo = parseFloat(this.state.piano.costo);
    if (isNaN(costo)) {
      alert("Errore nel campo COSTO");
      return;
    }

    // Controllo su date uniche
    const datesList = [];
    if (this.state.piano.rate) {
      for (const r of this.state.piano.rate) {
        if (datesList.indexOf(r.data) === -1) {
          datesList.push(r.data);
        } else {
          alert("Impossibile inserire più rate nella stessa data");
          return;
        }
      }
    }

    // Controllo totale importi
    let importoTot = 0;
    if (this.state.piano.rate) {
      for (const r of this.state.piano.rate) {
        importoTot += parseFloat(r.importo);
      }
    }

    if (importoTot !== costo) {
      alert("Il totale delle rate deve essere uguale al costo");
      return;
    }

    // Controllo eventuale duplicato di data consecutivo
    let error = false;
    for (let i = 1; i < this.state.piano.rate.length; i++) {
      const r1 = this.state.piano.rate[i - 1];
      const r2 = this.state.piano.rate[i];
      if (r1.data === r2.data) {
        error = true;
      }
    }

    if (error) {
      alert("Non possono esserci due rate con la stessa data");
      return;
    }

    // Qui salviamo il piano o richiamiamo una callback per l’aggiornamento
    this.props.onSalva(
      this.state.piano.costo,
      this.state.piano.rate ? this.state.piano.rate : [],
      this.rataStatus
    );
  }

  render() {
    if (this.state.isLoading) {
      return <div>Loading...</div>;
    }

    return (
      <div
        style={{
          border: "1px solid black",
          padding: "10px",
          marginBottom: "20px",
        }}
      >
        {this.props.compactMode !== true && (
          <TextInput
            name={"Costo"}
            value={this.state.piano?.costo || 0}
            onChange={(text) => {
              this.setState((prevState) => ({
                piano: {
                  ...prevState.piano,
                  costo: text,
                },
              }));
            }}
          />
        )}

        {this.props.compactMode !== true && (
          <FixButton
            title={"Aggiungi rata"}
            callback={this.aggiungiRata.bind(this)}
          />
        )}

        {/* Mostra le rate */}
        {this.state.piano?.rate?.map((rata, index) => {
          // Esempio di come estrarre i dati
          // (qui "rataDetails" e "status" eventualmente presi altrove, omessi)
          const mese = rata.mese; // <-- Il nostro nuovo campo
          return (
            <div
              key={index}
              style={{
                padding: "5px",
                border: "1px solid #888888",
                marginBottom: "10px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                onClick={() => {
                  if (this.props.compactMode) return;
                  this.setState({
                    rataStatusWidgetVisible: true,
                    rataIndex: index,
                    rata: {
                      data: rata.data,
                      importo: rata.importo,
                      mese: rata.mese, // Per passarlo al widget
                      corso: this.props.corso,
                    },
                  });
                }}
                style={{ cursor: "pointer", flex: 1 }}
              >
                <div style={{ fontSize: "16px" }}>Data: {rata.data}</div>
                <div style={{ fontSize: "16px" }}>Importo: {rata.importo}€</div>
                <div style={{ fontSize: "16px" }}>
                  Mese di riferimento: {mese || "-"}
                </div>
              </div>

              {this.props.compactMode !== true && (
                <div
                  style={{
                    color: "#ff0000",
                    cursor: "pointer",
                    paddingLeft: "10px",
                    whiteSpace: "nowrap",
                  }}
                  onClick={() => {
                    if (!window.confirm("Eliminare la rata?")) return;
                    // ESEMPIO: se la rata è già pagata, non la cancelliamo
                    // if (status === "PAGATA") {
                    //   alert("Impossibile eliminare una rata già pagata");
                    //   return;
                    // }
                    const piano = this.state.piano;
                    piano.rate.splice(index, 1);
                    this.setState({ piano });
                  }}
                >
                  Cancella
                </div>
              )}
            </div>
          );
        })}

        {this.props.compactMode !== true && (
          <FixButton
            title={"Aggiorna piano rate"}
            callback={this.salva.bind(this)}
          />
        )}

        <RataStatusWidgetCorso
          show={this.state.rataStatusWidgetVisible}
          rata={this.state.rata}
          isStudent={this.props.isStudent}
          onClose={(rataAggiornata) => {
            // Chiudi e aggiorna
            this.setState({ rataStatusWidgetVisible: false });
            if (!rataAggiornata) return;

            const newRata = {
              data: rataAggiornata.data,
              importo: rataAggiornata.importo,
              mese: rataAggiornata.mese, // <-- Salviamo anche il mese
            };

            const piano = this.state.piano;
            piano.rate[this.state.rataIndex] = newRata;
            this.setState({ piano });
          }}
        />

        <AddRata
          show={this.state.showAddRata}
          onClose={() => {
            this.setState({ showAddRata: false });
          }}
          isStudent={this.props.isStudent}
          // NOTA: ora onFinish riceve 4 parametri: data, importo, status, mese
          onFinish={(data, rata, status, mese) => {
            let rate = this.state.piano?.rate || [];
            rate.push({
              data,
              importo: rata,
              mese, // AGGIUNTO
            });

            // Puoi eventualmente aggiungere/inserire la logica per status
            // come la facevi prima, se serve.

            // Ordina per data, se necessario
            rate = rate.sort((l1, l2) => {
              const ll1 = moment(l1.data, "DD-MM-yyyy");
              const ll2 = moment(l2.data, "DD-MM-yyyy");
              return ll1 - ll2;
            });

            this.setState({ showAddRata: false });
            this.setState((prevState) => ({
              piano: {
                ...prevState.piano,
                rate: rate,
              },
            }));
          }}
          // Nuova callback per gestire multiple rate
          onFinishMultiple={(rateGenerate) => {
            let rate = this.state.piano?.rate || [];

            // Aggiungi tutte le rate generate
            rateGenerate.forEach((rataGenerata) => {
              rate.push({
                data: rataGenerata.data,
                importo: rataGenerata.importo,
                mese: rataGenerata.mese,
              });
            });

            // Ordina per data
            rate = rate.sort((l1, l2) => {
              const ll1 = moment(l1.data, "DD-MM-yyyy");
              const ll2 = moment(l2.data, "DD-MM-yyyy");
              return ll1 - ll2;
            });

            this.setState({ showAddRata: false });
            this.setState((prevState) => ({
              piano: {
                ...prevState.piano,
                rate: rate,
              },
            }));
          }}
        />
      </div>
    );
  }
}
